import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import {
  getGiftCard,
  getGiftCardBalance,
  getGiftCardBarberId,
  getInsufficientFunds,
} from '../reducer/giftCard/selectors';
import { closePayment } from '../reducer/currentPayment/actions';
import Charge from '../components/Charge';
import { PAYMENT_TYPE } from '../../../main/payment/constants';
import withAddPayment from '../hoc/withAddPayment';
import { getChargeAmount } from '../reducer/chargeAmount/selectors';
import { getIsFetching } from '../reducer/isFetching/selectors';
import { setGiftCard } from '../reducer/giftCard/actions';

const GiftCardChargeContainer = compose(
  withAddPayment,
  connect(
    (state) => {
      const giftCard = getGiftCard(state);
      return {
        code: giftCard,
        chargeAmount: getChargeAmount(state),
        balance: getGiftCardBalance(state),
        disabled: !giftCard || getIsFetching(state) || getInsufficientFunds(state),
        barberId: getGiftCardBarberId(state),
      };
    },
    { closePayment, reset: setGiftCard }
  ),
  withHandlers({
    charge: props => () => props.addPayment({
      type: PAYMENT_TYPE.giftCard,
      code: props.code,
      amount: props.chargeAmount,
      balance: props.balance,
      applicableToBarber: props.barberId,
    }, () => props.reset()).then(props.closePayment),
  })
)(Charge);

export default GiftCardChargeContainer;
